import { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  imageId: attr('string'),
  image: computed('imageId', 'store', 'uploadQueueEntry', function () {
    return this.imageId ? this.store.peekRecord('connect/image', this.imageId) : this.uploadQueueEntry;
  }),
  uploadQueueEntry: null,
  ordinal: attr('number', {
    defaultValue: 0
  })
}).reopenClass({
  _modelNameForMigration: 'object-image-membership'
});